var map = {
	"./NOT_icon.svg": "2373",
	"./button_anotovanie.svg": "3010",
	"./button_delete_anots.svg": "a5df",
	"./button_delete_highlights.svg": "be05",
	"./button_download.svg": "03a3",
	"./button_export.svg": "0ee0",
	"./button_home.svg": "9631",
	"./button_obnovenie.svg": "750b",
	"./button_volna_an.svg": "6070",
	"./cloud.svg": "2eb4",
	"./double-chevron-left.svg": "e5e7",
	"./double-chevron-right.svg": "2cae",
	"./iconDocuments.svg": "8e41",
	"./iconUpload.svg": "0a56",
	"./minus.svg": "e9b2",
	"./ok.svg": "76a5",
	"./plus.svg": "8a37",
	"./x.svg": "54f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";